import { ValidateChartNumberTouristInfo } from '@/types/user';
import styled from 'styled-components';

type Props = {
  infos: ValidateChartNumberTouristInfo[];
  chartNumber: string;
};

export default function ChartNumberDuplicateInfo({
  infos,
  chartNumber,
}: Props) {
  return (
    <Content>
      <Title>기존 고객과 같은 차트번호를 사용할까요?</Title>
      <Inner>
        <Caption>기존 사용 고객</Caption>
        <List>
          {infos.map((info, idx) => (
            <InfoItem key={`${info.passportNumber}-${idx}`}>
              <InfoItemText>{info.name}</InfoItemText>
              <InfoItemText>{info.nation}</InfoItemText>
              <InfoItemText>{info.passportNumber}</InfoItemText>
              <InfoItemText>{info.birthDate}</InfoItemText>
              <InfoItemText>{chartNumber}</InfoItemText>
            </InfoItem>
          ))}
        </List>
      </Inner>
    </Content>
  );
}

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 62px;
`;

const Title = styled.h3`
  color: var(--ktp-grayscale-gray_01, #000);
  font-size: 18px;
  font-weight: 700;
  line-height: 150%; /* 27px */
  margin: 0;
`;

const Caption = styled.p`
  color: var(--KTP-Grayscale-Gray_01, #000);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 24px */
  letter-spacing: -0.32px;
`;

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-height: 260px;
  overflow-y: auto;
`;

const InfoItem = styled.div`
  display: grid;
  grid-template-columns: 102px 50px 90px 80px 60px;
  gap: 22px;
  align-items: center;
  padding: 12px 16px;
  background: var(--ktp-grayscale-gray_12, #f4f4f4);
  border: 1px solid var(--mono-10, #e5e6e8);
  border-radius: 8px;
  font-family: 'Pretendard', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 150%; /* 21px */
  letter-spacing: -0.28px;
  color: var(--ktp-grayscale-gray_05, #777);
`;

const InfoItemText = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`;
